mutation RemoveCampaignSection($sectionId: ID!) {
    removeCampaignSection(sectionId: $sectionId)
}
